import type { LocationData } from "@/components/ui/mapbox-location-picker";
import type { AzureAddress } from "@/lib/types/azure";
import type { PlaceGisLocation } from "@/hooks/usePlaces";

type SavedGis = Pick<PlaceGisLocation, "formatted_address" | "latitude" | "longitude" | "geom">;

/**
 * A saved gis row as the map picker's `initialLocation` — the pin or drawn
 * area it opens on (so a shape can be edited, not redrawn). Null without
 * coordinates. Shared by the place form and the Overview map card.
 */
export function gisToLocationData(gis: SavedGis | null | undefined): LocationData | undefined {
  if (!gis || gis.latitude == null || gis.longitude == null) return undefined;
  return {
    address: { formattedAddress: gis.formatted_address ?? "" } as AzureAddress,
    coordinates: { latitude: gis.latitude, longitude: gis.longitude },
    geom: gis.geom ?? undefined,
  };
}

/** A gis row's coordinates as the picker's `initialCenter`. */
export function gisToCenter(
  gis: { latitude: number | null; longitude: number | null } | null | undefined,
): { latitude: number; longitude: number } | undefined {
  return gis?.latitude != null && gis.longitude != null
    ? { latitude: gis.latitude, longitude: gis.longitude }
    : undefined;
}
